import { DeleteIcon as DeleteIconIcon } from "components/common/Icons/DeleteIcon";
import { SmallContainer } from "components/common/SmallContainer/SmallContainer";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { useDeleteIcon } from "./useDeleteIcon";

export const DeleteIcon = () => {
    const { activeIcon, handleDelete } = useDeleteIcon();
    if (!activeIcon) return null;
    return (
        <ToolTip text={`Delete "${activeIcon.icon.title}" icon`}>
            <SmallContainer
                className={`group cursor-pointer py-3 px-3.5 border border-irGray-400 rounded-xl grid items-center bg-red-600 hover:bg-red-700 focus:bg-red-700`}
                onClick={handleDelete}
                data-testid="delete-modal-opener"
                id={`delete-icon-button`}
            >
                <div>
                    <DeleteIconIcon className="fill-white" width={16.84} height={20} />
                </div>
            </SmallContainer>
        </ToolTip>
    );
};
